// Períodos de fecha para filtrar listados — sin Vue ni red
// (pos-graciela-api/docs/SPEC_LISTADO_COMPRAS_v0.1.md RL-4).
//
// Todo trabaja con fechas `YYYY-MM-DD` y `Date` LOCALES armadas por
// componentes: `new Date('2026-10-22')` se interpreta en UTC y en Paraguay
// cae el día anterior.

export const PERIODOS = ['todas', 'dia', 'semana', 'mes'];

const aISO = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

const desdeISO = (iso) => {
  const [anio, mes, dia] = String(iso).split('-').map(Number);
  return new Date(anio, mes - 1, dia);
};

/** Hoy en la fecha local del navegador. */
export function hoyISO(ahora = new Date()) {
  return aISO(ahora);
}

/**
 * Rango inclusivo `{ desde, hasta }` del período que contiene `fechaISO`.
 * Semana de lunes a domingo; mes del 1 al último día. `todas` → sin rango.
 */
export function rangoDePeriodo(tipo, fechaISO) {
  if (tipo === 'todas' || !fechaISO) return { desde: null, hasta: null };
  const d = desdeISO(fechaISO);
  if (tipo === 'dia') return { desde: aISO(d), hasta: aISO(d) };
  if (tipo === 'semana') {
    const lunes = new Date(d.getFullYear(), d.getMonth(), d.getDate() - ((d.getDay() + 6) % 7));
    const domingo = new Date(lunes.getFullYear(), lunes.getMonth(), lunes.getDate() + 6);
    return { desde: aISO(lunes), hasta: aISO(domingo) };
  }
  if (tipo === 'mes') {
    return {
      desde: aISO(new Date(d.getFullYear(), d.getMonth(), 1)),
      hasta: aISO(new Date(d.getFullYear(), d.getMonth() + 1, 0))
    };
  }
  throw new Error(`Período desconocido: ${tipo}`);
}

/** La fecha de referencia movida `paso` períodos (±1). En mes, cae el día 1. */
export function moverPeriodo(tipo, fechaISO, paso) {
  const d = desdeISO(fechaISO);
  if (tipo === 'dia') return aISO(new Date(d.getFullYear(), d.getMonth(), d.getDate() + paso));
  if (tipo === 'semana') return aISO(new Date(d.getFullYear(), d.getMonth(), d.getDate() + 7 * paso));
  if (tipo === 'mes') return aISO(new Date(d.getFullYear(), d.getMonth() + paso, 1));
  return fechaISO;
}

/** `YYYY-MM-DD` → `DD/MM/YYYY`. */
export function fechaCorta(iso) {
  if (!iso) return '';
  const [anio, mes, dia] = String(iso).split('-');
  return `${dia}/${mes}/${anio}`;
}
